// extracted by mini-css-extract-plugin
module.exports = {"list":"vehicle-confirm-module--list--3D2kY","item":"vehicle-confirm-module--item--2J_Jb"};